import React from 'react'

import Icon, * as IconAnt from '@ant-design/icons'
import { Menu } from 'antd'
import { map } from 'lodash'
import PropTypes from 'prop-types'

const MenuSidebar = (props) => {
  return (
    <Menu
      className={`menuslider ${props.className}`}
      mode="inline"
      onSelect={props.onSelect}
      defaultSelectedKeys={props.defaultSelectedKeys}
    >
      {map(props.dataMenu, (data, key) => (
        <React.Fragment key={`${key}`}>
          <Menu.Item key={`${key}`} className="menuHeader">
            <span>{data.title}</span>
          </Menu.Item>
          {map(data.list, (category) => (
            <React.Fragment key={`${category.id}`}>
              <Menu.Item
                key={`/${category.slug}`}
                className="menuTitle"
                icon={<Icon component={IconAnt[category.iconName]} />}
              >
                <span>{category.title}</span>
              </Menu.Item>
              {map(category.submenu, (submenu) => {
                if (submenu.__component === 'elements.article') {
                  return (
                    <Menu.Item key={`/${category.slug}/${submenu.slug}`} className="menuItem">
                      <div id="menu-circle" className="circleIcon" />
                      {submenu.label}
                    </Menu.Item>
                  )
                } else {
                  return (
                    <Menu.SubMenu
                      key={`${category.slug}/${submenu.slug}`}
                      title={submenu.label}
                      className="menuSubmenu"
                      icon={<div id="menu-circle" className="circleIcon" />}
                    >
                      {map(submenu.article, (article) => (
                        <Menu.Item
                          key={`/${category.slug}/${submenu.slug}/${article.slug}`}
                          className="menuItem"
                        >
                          <div id="menu-circle" className="circleIcon" />
                          {article.label}
                        </Menu.Item>
                      ))}
                    </Menu.SubMenu>
                  )
                }
              })}
            </React.Fragment>
          ))}
        </React.Fragment>
      ))}
    </Menu>
  )
}

MenuSidebar.propTypes = {
  className: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  defaultSelectedKeys: PropTypes.string,
  dataMenu: PropTypes.array.isRequired,
}

MenuSidebar.defaultProps = {
  className: '',
  defaultSelectedKeys: '',
}

export default MenuSidebar
